export default __webpack_public_path__ + "static/media/game_icon2.0a919219.png";